import { combineReducers } from 'redux';
import AppReducer from './appReducer';
import UserReducer from './userReducer';
import DataReducer from './dataReducer';
import UIReducer from './uiReducer';
import RegionsReducer from './regionsReducer';
import RestaurantsReducer from './restaurantsReducer';
import BrandsReducer from './brandsReducer';
import ManufacturersReducer from './manufacturersReducer';
import OperationHoursReducer from './operationHoursReducer';
import LoaderReducer from './loaderReducer';
import ManageDaysOffReducer from './manageDaysOffReducer';
import HolidaysReducer from './holidays';
import KioskTypesReducer from './kioskTypesReducer';
import SnackbarReducer from './snackbarReducer';
import EquipmentsReducer from './equipmentsReducer';
import RoutineDaysReducer from './routineDaysReducer';
import ModelsReducer from './modelsReducer';
import CategoriesReducer from './categoriesReducer';
import SuppliersReducer from './suppliersReducer';
import ApprovalTypesReducer from './approvalTypesReducer';
import PlatformsReducer from './platformsReducer';
import CommodityGroupsReducer from './commodityGroupsReducer';
import CalibrationProfilesReducer from './calibrationProfilesReducer';
import UtilsReducers from './utilsReducers';
import HierarchyReducer from './hierarchy';
import ReportingUnitsReducer from './reportingUnitsReducer';
import ProductGroupTranslationReducer from './productGroupTranslationReducer';
import EquipmentSpecificReducer from './equipmentSpecificReducer';
import RestaurantZonesReducer from './restaurantZonesReducer';
import PosTypesReducer from './posTypesReducer';
import LastAction from './lastActionReducer';
import AttributesReducer from './attributesReducer';
import FocusedAttributeReducer from './focusedAttributeReducer';
import ServicesReducer from './servicesReducer';
import ShelfUnitsReducer from './shelfUnitsReducer';
import UnitsOfMeasuresReducer from './unitsOfMeasuresReducer';
import MenuItemsReducer from './menuItemsReducer';
import NewOperationHoursReducer from './newOperationHoursReducer';
import UploadHistoryReducer from './uploadHistoryReducer';

const rootReducer = combineReducers({
  AppReducer,
  ApprovalTypesReducer,
  AttributesReducer,
  FocusedAttributeReducer,
  ServicesReducer,
  BrandsReducer,
  CalibrationProfilesReducer,
  CategoriesReducer,
  CommodityGroupsReducer,
  DataReducer,
  EquipmentSpecificReducer,
  EquipmentsReducer,
  HierarchyReducer,
  HolidaysReducer,
  KioskTypesReducer,
  LastAction,
  LoaderReducer,
  ManageDaysOffReducer,
  ManufacturersReducer,
  MenuItemsReducer,
  ModelsReducer,
  OperationHoursReducer,
  PlatformsReducer,
  PosTypesReducer,
  ProductGroupTranslationReducer,
  RegionsReducer,
  ReportingUnitsReducer,
  RestaurantZonesReducer,
  RestaurantsReducer,
  RoutineDaysReducer,
  ShelfUnitsReducer,
  SnackbarReducer,
  SuppliersReducer,
  UIReducer,
  UnitsOfMeasuresReducer,
  UserReducer,
  UtilsReducers,
  NewOperationHoursReducer,
  UploadHistoryReducer,
});

export default rootReducer;

export type RootStateType = ReturnType<typeof rootReducer>;
